import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type PageLayoutProps = { className?: string } & PropsWithChildren;

export const PageLayout: FC<PageLayoutProps> = ({ className, children }) => {
  return <div className={twMerge('flex grow flex-col gap-6 p-8 pb-12 bg-primary-background', className)}>{children}</div>;
};
